import { Subject, BehaviorSubject } from 'rxjs';

export const eventSubject = new Subject();
export const messageStatusSubject = new Subject();
export const eventReadSubject = new BehaviorSubject();
